import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@geome/react-next/lib/hooks/i18n";
import { usePublishUserInteraction } from "@geome/react-next/lib/hooks/userInteraction";
export const ButtonLink = ({ translationToken, text, className = "", href, target = "_self", keyboardFocusable = true, }) => {
    const { translate } = useI18n();
    const [onClickButtonLink] = usePublishUserInteraction("button-link", "click");
    return (_jsx("a", { className: `button-link ${className}`, href: href, target: target, tabIndex: keyboardFocusable ? 0 : -1, onClick: () => onClickButtonLink({ href, translationToken }), children: text ? text : translate(translationToken) }));
};
